import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzAlertComponent, NzAlertModule } from 'ng-zorro-antd/alert';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberLegacyComponent } from 'ng-zorro-antd/input-number-legacy';
import { NzFormModule } from 'ng-zorro-antd/form';
import { JsonFormsNewComponent } from './json-forms-new-popup/json-forms-new/json-forms-new.component';
import { JsonFormsNodeNewComponent } from './json-forms-new-popup/json-forms-node-new/json-forms-node-new.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule } from '@ngx-translate/core';
import { JsonViewerComponent } from '../system-utils/json-viewer/json-viewer.component';
import { SharedModule } from '../shared-module/shared-module.module';
import { NzInputNumberLegacyModule } from 'ng-zorro-antd/input-number-legacy';
import { MatDividerModule } from '@angular/material/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
  declarations: [
    JsonFormsNewComponent,
    JsonFormsNodeNewComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    FlexLayoutModule,
    NzAlertModule,
    NzInputModule,
    NzInputNumberLegacyComponent,
    NzFormModule,
    NzCardModule,
    NzCheckboxModule,
    NzButtonModule,
    TranslateModule,
    NzInputNumberLegacyModule,
    SharedModule,
    MatDividerModule,
    NzIconModule
  ],
  exports:[
    JsonFormsNewComponent
  ]
})
export class JsonEditorModule { 

}
